import dayjs from "dayjs";

export const DEFAULT_END_DATE = "9999-12-31 11:59:59Z";
export const DEFAULT_END_DATE_DAYJS = dayjs(DEFAULT_END_DATE);

export const dateOrder = (delimiter = "/") => {
  const userLocale = navigator.language || navigator.userLanguage;
  if (userLocale === "en-US") {
    return `MM${delimiter}DD`;
  }
  return `DD${delimiter}MM`;
};

export const dateDisplay = (
  date,
  { utc = false, time = false, timezone = null, alter = false, delimiter = "/" } = {
    utc: false,
    timezone: null,
    time: false,
    alter: false,
    delimiter: "/",
  },
) => {
  let dayjsDate = utc ? dayjs.utc(date) : dayjs(date);
  if (timezone) dayjsDate = dayjsDate.tz(timezone);
  if (DEFAULT_END_DATE_DAYJS.isSame(dayjsDate, "year") || !dayjsDate.isValid()) return null;
  if (alter) {
    const formatString = time ? ": h:mma" : "";
    return dayjsDate.format(`${dateOrder(delimiter)}${delimiter}YY${formatString}`);
  }

  const formatString = time ? "MMM Do YYYY HH:mm" : "MMM Do YYYY";
  return dayjsDate.format(formatString);
};
